import React, { useState } from 'react';
import { AnimatePresence, motion } from "framer-motion";

export default function Project({ Lang, project, index, inView }) {
    const [infoVisible, setInfoVisible] = useState(false);

    const handleMouseEnter = () => {
        if (window.innerWidth > 768) {
            setInfoVisible(true);
        }
    };

    const handleMouseLeave = () => {
        if (window.innerWidth > 768) {
            setInfoVisible(false);
        }
    };

    return (
        <motion.div initial={{ x: -500, opacity: 0 }}
            animate={inView ? { x: 0, opacity: 1 } : { x: -500, opacity: 0 }}
            transition={{ delay: (0.4 + index) * 0.2 }}
            className='relative px-4 md:px-8 py-10 w-full border border-white/10 shadow-lg shadow-white/40'
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
        >
            <div className='absolute inset-0'>
                <img src={project.image} alt={project.title[Lang]} className="w-full h-full object-cover" loading="lazy" onError={(e) => e.target.src = "/assets/images/default.png"}
                />
                <div className="absolute inset-0 bg-black/90 transition duration-300 "></div>
            </div>
            <div className={`relative z-10 flex justify-between items-center ${index % 2 !== 0 && "md:flex md:flex-row-reverse"}`}>
                <div className='flex flex-col gap-2'>
                    <div className='text-lg md:text-4xl font-medium text-white overflow-y-hidden'>{project.title[Lang]}</div>
                    <div onClick={() => setInfoVisible(!infoVisible)} className='text-xs md:text-lg font-medium text-cyan-400 md:hidden underline underline-offset-4 uppercase'>
                        {infoVisible ? (Lang === 'Ar' ? "عرض أقل" : (Lang === 'Fr' ? "Voir moins" : "See Less")) :
                            (Lang === 'Ar' ? "عرض المزيد" : (Lang === 'Fr' ? "Voir plus" : "See More"))}
                    </div>
                </div>
                <div className='text-xs md:text-sm font-bold text-white/80'>{project.date[Lang]}</div>
            </div>
            <AnimatePresence>
                {infoVisible && (
                    <motion.div initial={{ y: -20, opacity: 0 }}
                        animate={{ y: 0, opacity: 1 }}
                        exit={{ y: -20, opacity: 0 }}
                        transition={{ duration: 0.4 }}
                        className="mt-10 relative z-10 ">
                        <div className='flex flex-col md:flex-row justify-between items-center gap-5 md:gap-20'>
                            <div className='w-full'>
                                <div className="text-white/80">
                                    {project.description[Lang]}
                                </div>
                                <span className="flex flex-wrap gap-2 text-cyan-400 md:gap-5 mt-2 md:mt-4">
                                    {project.tools.map((tool, i) => (
                                        <span key={i}>{tool}</span>
                                    ))}
                                </span>
                                <div className="mt-3 md:mt-5 flex flex-wrap gap-4 md:gap-6 text-white">
                                    {project.hasOwnProperty('liveLink') && (
                                        <a
                                            href={project.liveLink}
                                            target="_blank"
                                            rel="noreferrer"
                                            className="px-3 py-2 uppercase duration-500 border rounded-full md:py-4 md:px-7 border-white/20 hover:bg-cyan-400/20 hover:border-cyan-400/20"
                                        >
                                            {Lang === 'Ar' ? 'تصفح الموقع' : (Lang === 'Fr' ? 'Site en ligne' : 'Live Site')}
                                        </a>
                                    )}
                                    {project.hasOwnProperty('sourceCodeLink') && (
                                        <a
                                            href={project.sourceCodeLink}
                                            target="_blank"
                                            rel="noreferrer"
                                            className="px-3 py-2 uppercase duration-500 border rounded-full md:py-4 md:px-7 border-white/20 hover:bg-cyan-400/20 hover:border-cyan-400/20"
                                        >
                                            {Lang === 'Ar' ? 'المصدر' : (Lang === 'Fr' ? 'Code source' : 'Source Code')}
                                        </a>
                                    )}
                                </div>
                            </div>
                            <img src={project.image} alt={project.title} className="md:w-[28%] rounded-xl" loading="lazy" onError={(e) => e.target.src = "/assets/images/default.png"} />
                        </div>
                    </motion.div>
                )}
            </AnimatePresence>
        </motion.div>
    );
}
